import(/* webpackMode: "eager", webpackExports: ["MediaPoster"] */ "/app/app/media/ui/media-list/ui/poster/media-poster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Favorites"] */ "/app/components/favorites/favorites.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/components/logo/logo.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/marquee-items/marquee-items.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/app/components/navigation/navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsSearchBar"] */ "/app/components/news-search-bar/news-search-bar.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/shared/news-detail/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NewsPoster"] */ "/app/components/shared/news-poster/news-poster.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/shared/null/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/components/shared/pagination/pagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/shared/preloader/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TgWidget"] */ "/app/components/tg-widget/tg-widget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useDebounce"] */ "/app/hooks/useDebounce.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useFetchClientSide"] */ "/app/hooks/useFetchClientSide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatePresence","motion","div"] */ "/app/node_modules/framer-motion/dist/es/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/public/arrow-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/footer-left.png");
;
import(/* webpackMode: "eager" */ "/app/public/footer-right.png");
;
import(/* webpackMode: "eager" */ "/app/public/not-image.png");
